import { z } from 'zod'
import {
  Address,
  HexNumber,
} from '@lukso/controllerapps-sharedlogic-primitives'

import { InitialControllerAddress } from '../../../cross-chain-deployment/InitialControllerAddress'

export const InitialControllerAddressSchema = z.string()

type InitialControllerAddressReportText = z.infer<
  typeof InitialControllerAddressSchema
>

export function mapDomainToReportText(
  address: InitialControllerAddress
): InitialControllerAddressReportText {
  return address.getChecksumValue()
}

export function mapReportTextToDomain(
  reportText: InitialControllerAddressReportText
): InitialControllerAddress {
  return InitialControllerAddress.create({
    initialControllerAddressValue: Address.create({
      addressValue: HexNumber.create({ hexNumberValue: reportText }),
    }),
  })
}
